export { TestimonialWall as PullQuoteSection } from "../cms-collections"
export type { TestimonialWallProps as PullQuoteSectionProps } from "../cms-collections"